<template>
	<div class="prestep card py-10">
		<v-card class="mx-auto prestep-card">
			<div class="prestep-card-logo">
				<img :src="$imgUrl(client.logo)">
			</div>

			<div class="prestep-card-close" @click="next('closed')">
			    <img src="@/assets/img/clear.png" width="15">
			</div>

			<v-img v-if="currentCard.image"
				class="card-top-image"
				:src="$imgUrl(currentCard.image)"
				:alt="currentCard.image_alt"
				height="200px" 
			/>

			<p class="card-top-image-credits" v-if="currentCard.image_credit" v-html="currentCard.image_credit">
				{{ currentCard.image_credit }}
			</p>

			<v-card-title>{{ $processText(currentCard.title) }}</v-card-title>

			<v-card-text>
				<div class="mb-5" v-html="$processText(currentCard.wysiwyg)"></div>
					
				<v-text-field ref="to" v-model="to" solo placeholder="Ange adress/plats"></v-text-field>

				<div 
					v-if="currentCard.type_options && currentCard.type_options.wysiwyg_transportation && ! currentCard.type_options.input_home_address" 
					v-html="$processText(currentCard.type_options.wysiwyg_transportation)"
				></div>

				<div class="mt-3 mb-5" v-if=" ! currentCard.type_options.input_home_address">
					<div 
					    class="coach-card-btn"
					    :class="isActive(layer.id)"
					    v-for="layer in layers"
					    :key="layer.id"
					    :style="{'background-color': layer.icon_font_color, 'border-color': layer.icon_font_color, 'color': '#fff'}"
					    @click="setTransportation(layer)"
					>
				        <i v-if="layer.icon_font" :class="layer.icon_font"></i>

				        <v-img  
							v-if="layer.icon && ! layer.icon_font"
				        	:src="$imgUrl(layer.icon)"
				        	height="20px"
				        />

					    {{ layer.__title }}
					</div>

					<div class="coach-card-btn">Annat</div>
				</div>
				
				<div class="prestep-bottom" :class="{between: index > 0}">
					<div class="btn" v-if="index > 0" @click="prev()">Tillbaka</div>

					<div class="btn" @click="next('continue')">{{ currentCard.type_options && currentCard.type_options.btn_text || 'Gå vidare' }}</div>
				</div>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
export default {
    name: 'PreStep',
    props: ['cards'],

    mounted() {
		this.$store.state.prestepOpen = true

		// GMaps autocomplete
		if (this.mapsApi) {
			let autoComplete = new this.mapsApi.maps.places.Autocomplete(this.$refs.to.$el.querySelector('input'), 
			    {componentRestrictions: {country: 'se'}})

			autoComplete.addListener('place_changed', () => {
				this.$store.state.mapPreserveViewport = true
				this.$store.state.directions[this.currentCard.type_options.input_home_address ? 'from' : 'to'] = autoComplete.getPlace().formatted_address

				if ( ! this.currentCard.type_options.input_home_address) {
					this.$setCookie('toDestination', this.$store.state.directions.to)
				}

			    this.$metric({'event': 'prestep_interaction', 'InteractionType': 'destination'})
			})
		}

		this.$metric({'event': 'prestep_interaction', 'InteractionType': 'loaded'})
    },

    data() {
    	return {
    		to: '',
			activeLayer: null,
			index: 0
    	}
    },

    methods: {
    	isActive(id) {
    		if ( ! this.activeLayer) {
    			return null
    		}

    		return this.activeLayer.id === id ? 'active' : 'not-active'
    	},

    	next(type) {
    		this.$metric({'event': 'prestep_interaction', 'InteractionType': type})

    		if (type === 'closed') {
    			this.close()
    		}

    		if (this.index + 1 === this.cards.length) {
    			this.close()
    		} else {
    			this.to = ''
    			this.index++
    		}
    	},

    	prev() {
    		this.to = ''
    		this.index--
    	},

    	close(type) {
    		this.$store.state.prestepOpen = false
    		this.$destroy();
    	},

    	setTransportation(layer) {
    		if (this.activeLayer && ! this.activeLayer.show_as_default) {
    			this.activeLayer.active = false
    			this.activeLayer.point_categories = this.activeLayer.point_categories.map(c => ({...c, active: false}))
    		}

    		this.activeLayer = layer

			if (layer.title.includes('Promenad')) { this.$store.state.directions.travelMode = 'WALKING' }
			if (layer.title.includes('Cykel')) { this.$store.state.directions.travelMode = 'BICYCLING' }
			if (layer.title.includes('Kollektiv')) { this.$store.state.directions.travelMode = 'TRANSIT' }
			
			layer.active = true
    	    layer.point_categories = layer.point_categories.map(c => ({...c, active: layer.active}))

    	    this.$metric({'event': 'prestep_interaction', 'InteractionType': 'transportation', 'TransportationType': layer.title})
    	},
    },

    computed: {
    	currentCard() {
    		return this.cards[this.index]
    	},

		mapsApi() {
		    return this.$store.state.mapsApi
		},

		client() {
			return this.$store.state.client
		},

		layers() {
		    return this.$store.getters.translatedLayers
		        .filter(l => l.show_in_menu && ! l.hidden)
		        .filter(l => l.title !== 'Mer')
		},
    }
}
</script>